<template>
  <div>
    <div class="banner withoutImg">
      <div class="container">
        <div class="caption">
          <h1>{{$route.query.history?'我的浏览历史':'最新资讯'&&$route.query.bookmarks?'我的书签':'最新资讯'}}</h1>
          <div>
            <p>{{$route.query.history?'历史浏览的详细内容':'来自勃艮第的最新资讯'&&$route.query.bookmarks?'收藏到书签的详细内容':'来自勃艮第的最新资讯'}}</p>
          </div>
        </div>
      </div>
    </div>

    <div class="container">
      <p>&nbsp;</p>
      <div class="breadcrumbWrap">
        <div class="breadcrumb">
          <span property="itemListElement" typeof="ListItem">
            <a
              property="item"
              typeof="WebPage"
              title="Go to Jasper Morris Inside Burgundy."
              href="#/"
              class="home"
            >
              <span property="name">首页</span>
            </a>
            <meta property="position" content="1">
          </span> /
          <span property="itemListElement" typeof="ListItem">
            <a property="item" typeof="WebPage" title="最新资讯" href="#/report" class="home">
              <span property="name">{{$route.query.history?'我的浏览历史':'最新资讯'&&$route.query.bookmarks?'我的书签':'最新资讯'}}</span>
            </a>
            <meta property="position" content="2">
          </span>/
          <span property="itemListElement" typeof="ListItem">
            <span property="name">{{contentDetail.title}}</span>
            <meta property="position" content="3">
          </span>
          <img src="./../assets/bookmark_before.png" alt @click="shuqian(contentDetail.id)">
        </div>
      </div>
    </div>
    <section class="innerPage">
      <div class="container">
        <rightMenu title="分类" :menudata="rightListdata" @OnClick="rightClick"/>

        <div class="leftCol" style="max-width: 80%;margin-left: auto;margin-right: auto;">
          <div>
            <h4 style="text-align: left;">{{contentDetail.title}}</h4>
          </div>
          <div style="margin-top:25px;">
            <div style="float: left">
              <img :src="contentDetail.avator" style="width: 50px;border-radius:25px;">
            </div>
            <div style="font-size: 14px;">
              <div>
                <span style="margin-left: 15px;">作&nbsp;&nbsp;者：{{contentDetail.author}}</span>
              </div>
              <div>
                <span style="margin-left: 15px;">日&nbsp;&nbsp;期：{{contentDetail.createTime}}</span>
              </div>
            </div>
          </div>
          <div style="margin-top:25px;">
            <img :src="contentDetail.image">
          </div>
          <section style="margin-top:25px;" v-html="contentDetail.contentHtml"></section>
        </div>
      </div>
    </section>
  </div>
</template>
<script>
import ajax from "../ajax";
import searchBox from "../template/search";
import rightMenu from "../template/rightMenu";
export default {
  data() {
    return {
      contentDetail: {},
      rightListdata: {},
      userId: "",
      relatedType: "",
      relatedId: ""
    };
  },
  components: {
    rightMenu,
    searchBox
  },
  mounted() {},
  created() {
    this.getRightdata();
    if (this.$route.query.id) this.getcontent(this.$route.query.id);
  },
  watch: {
    $route(newValue) {
      console.log(newValue);
      this.getdetail();
    }
  },
  methods: {
    shuqian(id) {
      ajax
        .getVserInfe(
          {
            userId: this.$store.state.userdata.userId,
            relatedType: 1,
            relatedId: id
          }
          // this.$store.state.userdata.userId
        )
        .then(res => {
          console.log(res.data);
          alert("已添加到书签");
        });
      console.log(id);
    },
    getRightdata() {
      ajax.getNewsCategories().then(res => {
        this.rightListdata = res.data;
      });
    },
    rightClick(data) {
      if (!data.child && data.id)
        this.$router.push({
          path: "/latestinformation",
          query: { id: data.id }
        });
    },
    getdetail() {
      ajax.getNewDetail(this.$route.query.id).then(res => {
        this.contentDetail = res.data;
      });
    },
    getcontent(id) {
      ajax.getNewDetail(id).then(res => {
        this.contentDetail = res.data;
        console.log(res);
      });
    },
    changeActive($event) {
      $event.currentTarget.style = "border-bottom: 4px solid #990033;";
    },
    removeActive($event) {
      $event.currentTarget.style = "";
    }
  }
};
</script>
<style>
.s1 {
  line-height: 39px;
}
.entry {
  margin-top: 40px;
}
.entry-ziti {
  flex-flow: row nowrap;
  justify-content: space-between;
  display: flex;
  margin-bottom: 20px;
}
</style>



// WEBPACK FOOTER //
// src/components/Latestinformation.vue